import { faMaximize } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { memo, useCallback, useState } from 'react'
import styled from 'styled-components'
import Modal from '~/prix/react/components/modal'

const ImageContainer = styled.div`
  position: relative;
  display: inline-block;
  min-width: 100%;
`

const StyledImage = styled.img`
  max-width: 100%;
  height: auto;
  transition: max-width 0.3s ease;
`

const ExpandButton = styled.button`
  position: absolute;
  top: 4px;
  right: 4px;
  background: #fff;
  color: ${({ theme }) => theme.colors.primary};
  border: none;
  border-radius: 4px;
  padding: 6px 8px 4px;
  cursor: pointer;
  opacity: 0;
  transition: background-color 0.2s ease;
  font-size: 16px;
  opacity: 1;

  &:hover {
    background: #e2e7e8;
  }
`

const ExpandedImage = styled.img`
  max-width: 100%;
  height: auto;
  padding: 16px;
`

interface ExpandableImageProps {
  src: string
  alt?: string
  onLoad?: () => void
}

const ExpandableImage = ({ src, alt, onLoad }: ExpandableImageProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)

  const toggleExpand = useCallback(() => {
    setIsExpanded(!isExpanded)
  }, [isExpanded, setIsExpanded])

  const handleLoad = useCallback(() => {
    setIsLoaded(true)
    onLoad?.()
  }, [onLoad, setIsLoaded])

  return (
    <>
      <ImageContainer>
        <StyledImage src={src} alt={alt || ''} onLoad={handleLoad} loading='eager' />
        {isLoaded && (
          <ExpandButton
            onClick={toggleExpand}
            data-tooltip-id={!isExpanded ? 'tooltip-bubble-action' : undefined}
            data-tooltip-content={!isExpanded ? 'Expandir' : undefined}
          >
            <FontAwesomeIcon icon={faMaximize} />
          </ExpandButton>
        )}
      </ImageContainer>

      {isExpanded && (
        <Modal
          isOpen={isExpanded}
          onClose={() => setIsExpanded(false)}
          baseWidth='auto'
          baseHeight='auto'
          styles={{
            overlay: {
              zIndex: 10,
            },
          }}
        >
          <ExpandedImage src={src} alt={alt} />
        </Modal>
      )}
    </>
  )
}

export default memo(ExpandableImage)
